import { useQuery } from "@tanstack/react-query";

import { api } from "./client";
import type { DashboardSummary } from "@/types";

export function useDashboardSummary() {
  return useQuery({
    queryKey: ["dashboard", "summary"],
    queryFn: async () => {
      const { data } = await api.get<DashboardSummary>(
        "/api/v1/dashboard/summary",
      );
      return data;
    },
    refetchInterval: 30_000,
  });
}
